import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
// Fuentes servidas desde la propia app (sin depender de Google Fonts en el viaje)
import '@fontsource/zen-kaku-gothic-new/400.css';
import '@fontsource/zen-kaku-gothic-new/700.css';
import '@fontsource/zen-kaku-gothic-new/900.css';
import '@fontsource/shippori-mincho-b1/800.css';
import '@fontsource/dotgothic16/400.css';
import './estilos/ventanilla.css';
import './estilos/app.css';
import { App } from './App.tsx';

// Que Android no borre la copia del viaje ni lo apuntado para hacer sitio
void navigator.storage?.persist?.();

createRoot(document.getElementById('raiz')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
